import React, { useEffect, useState } from 'react'
import { useKeycloak } from 'react-keycloak'
import { Icons } from '@fabricks/ui-components'
import { MetricCardElement } from '../../../components/DashboardItems/MertricCardElement'
// @ts-ignore
import { BoxTypeStatDto, StatisticDto, useGetBoxTypeStatsForBoxTypeMetricQuery } from '../../../api/models'
import { getContext } from '../../../services/apiService'
import { transformIconColor, useMetricStatus } from '../../../services/metricCardService'
import { useHistory } from "react-router-dom";
import Navigation from "../../../constants/navigation";

export const BoxTypeMetricCard: React.FC<any> = () => {
    const history = useHistory()
    const [keycloak] = useKeycloak()
    const [metricStatus, setMetricStatus] = useMetricStatus()
    const [statData, setStatData] = useState<BoxTypeStatDto>({})
    const { data, loading, error } = useGetBoxTypeStatsForBoxTypeMetricQuery({ context: getContext(keycloak.token) })

    useEffect(() => {
        if (data) {
            setStatData((data.getStatistics as StatisticDto).boxTypeStat as BoxTypeStatDto)
        }

        if (statData.count != null && statData.valid != null) {
            return () => {}
        }

        // @ts-ignore
        if (statData.valid < statData.count) {
            setMetricStatus({
                status: 'warning',
                // @ts-ignore
                message: `${statData.count - statData.valid} invalid box type definitions`,
            })
        }
        if (error) {
            setMetricStatus({ status: 'error', message: error.message })
        }
        return () => {}
    }, [data, error, setMetricStatus, statData])

    const ofValue = statData.count || 0
    const value = statData.active || 0

    const handleOnMetricStatus = () => {
        if (metricStatus.status === 'error') {
            return history.push(`/masterdata/boxTypes?filter=isInvalid`)
        }
        return history.push(`/masterdata/boxTypes`)
    }

    return (
        <MetricCardElement
            initLoadingTime={1500}
            isLoading={loading}
            title="Active Box Types"
            ofValue={ofValue}
            value={value}
            statusType={metricStatus.status}
            onClickMetricStatus={handleOnMetricStatus}
            statusMessage={metricStatus.message}
            iconColor={transformIconColor(metricStatus)}
            icon={<Icons.Inbox />}
        />
    )
}
